import React from 'react';
import Header from './Header';
import Footer from './Footer';
import InscriptionTopBanner from './InscriptionTopBanner';
import MaintenanceSplash from './MaintenanceSplash';

const Layout = ({ children }) => {
  return (
    <MaintenanceSplash>
      <div className="min-h-screen flex flex-col">
        <InscriptionTopBanner />
        <Header />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
      </div>
    </MaintenanceSplash>
  );
};

export default Layout;
